import {Mental} from "../Mental";
import {TweenLite} from "gsap";
import {FeaturePresentationHelper} from "../utils/FeaturePresentationHelper";

export class MentalEnhancerFrame extends PIXI.Container {
    private _enhancerFrameMask: PIXI.Graphics;
    private _enhancerFrame: PIXI.Sprite[][] = [];

    constructor() {
        super();
        this.initAnimation();
    }

    private initAnimation(): void {
        for (let i: number = 0; i < 2; i++) {
            this._enhancerFrame[i] = [];
            const topFrame: PIXI.Sprite = new PIXI.Sprite(Mental.assetLoader.getTextures("e_top_frame")[0]);
            const bottomFrame: PIXI.Sprite = new PIXI.Sprite(Mental.assetLoader.getTextures("e_bottom_frame")[0]);
            topFrame.anchor.set(0.5, 0);
            bottomFrame.anchor.set(0.5);

            topFrame.scale.y *= -1;
            bottomFrame.scale.y *= -1;

            this.addChild(topFrame);
            this._enhancerFrame[i].push(topFrame);

        }

        this._enhancerFrameMask = new PIXI.Graphics();
        this._enhancerFrameMask.beginFill(0xffffff, 0.001);
        this._enhancerFrameMask.drawRect(0, 0, 155 * 3, 495);
        this._enhancerFrameMask.endFill();
        this._enhancerFrameMask.pivot.set(0.5);
        this._enhancerFrameMask.position.set(130, 190);
        this.addChild(this._enhancerFrameMask);

        this.resetEnhancerFramePositions();
    }

    private resetEnhancerFramePositions(): void {
        for (let i: number = 0; i < this._enhancerFrame.length; i++) {
            const reelId: number = i == 0 ? 1 : 3;
            const width: number = 160;
            const height: number = this._enhancerFrame[i][0].height;
            const offset: number = 90;

            this._enhancerFrame[i][0].mask = this._enhancerFrameMask;

            this._enhancerFrame[i][0].position.set((144 * reelId) + width / 2.2, (offset + 198 * 2.48) + height);
            this._enhancerFrame[i][0].width = 160;
        }
    }

    public hideEnhancerBorder(borderReel: number): void {
        this._enhancerFrame[borderReel].forEach((value1: PIXI.Sprite) => {
            value1.visible = false;
        });
    }


    public showAllEnhancerReelBorder(): void {
        this.resetEnhancerFramePositions();
        this._enhancerFrame.forEach((value: PIXI.Sprite[]) => {
            value.forEach((value1: PIXI.Sprite) => {
                value1.visible = true;
            });
        });
    }

    public expandEnhancerFrameOnXWays(reelId: number, symbolHeight: number, symSize: number, time: number): void {
        reelId = (reelId == 1) ? 0 : 1;
        const posY: number = 186 + (495 - symbolHeight) + this._enhancerFrame[reelId][0].height;
        TweenLite.to(this._enhancerFrame[reelId][0], {duration: time, y: posY});
    }

    public resizeEnhancerFrameOnXWayXSplit(reelId: number): void {
        const symbolHeight: number = FeaturePresentationHelper._symbolHeightOnReel[reelId] * Mental.model.gameData.currentSymbolSize[reelId][2];
        const time: number = 0.1;
        reelId = (reelId == 1) ? 0 : 1;
        const posY: number = 186 + (495 - symbolHeight) + this._enhancerFrame[reelId][0].height;
        TweenLite.to(this._enhancerFrame[reelId][0], {duration: time, y: posY});
    }
}